<template>
  <div class="all-height">
    <div class="d-flex mb-4">
      <div class="d-flex align-center" v-if="pendingCountDisplay">
        <CountSection class="gap-10"
          :count="dataStatusCount.open"
          :network-label="$nova.labelsName('access_management','commentary_pending_label','Pending')"
          :count-label="$nova.labelsName('access_management','commentary_requests_label','Requests')"
        />
      </div>
      <v-spacer></v-spacer>
    </div>
    <div v-if="formatteddata.length > 0" class="">
      <lb-datatablenew :headers="visibleHeaders" :items="formatteddata"
        :enableslot="['created_at', 'submittername', 'typetext','approvedby','approvedon', 'action', 'stage']"
        :loading=false :sortByDate=true>
        <template v-slot:typetext="{ item }">
          <div label :color="colors[item.type]"><span>{{item.typetext}}</span></div>
        </template>
        <template v-slot:created_at="{ item }">
          <span>{{$nova.formatDateTime(item.created_at)}}</span>
        </template>
        <template v-slot:submittername="{ item }">
          <div class="d-flex flex-column align-start gap-1" v-if="item.submitter_detail">
            <span>{{item.submitter_detail?.name}}</span>
            <v-chip class="mailChip">
              <span class="textLowercase">{{item.submitter_detail?.email}}</span>
            </v-chip>
          </div>
        </template>
        <template v-slot:approvedby="{ item }">
          <div class="d-flex flex-column align-start gap-1">
            <span>{{ item.approver_detail?.name || ""}}</span>
            <v-chip class="mailChip">
              <span class="textLowercase">{{ item.approver_detail?.email || "" }}</span>
            </v-chip>
          </div>
        </template>
        <template v-slot:approvedon="{ item }">
          <span>{{ $nova.formatDateTime(item.approvedate) || "" }}</span>
        </template>
        <template v-slot:stage="{ item }">
          <StatusIndicator
            v-if="item.stage === 'Open'"
            :variant="STATUS_VARIANTS.OPEN"
            customLabel="Open"
            size="sm"
          />
          <StatusIndicator
            v-else-if="item.stage === 'Approved'"
            :variant="STATUS_VARIANTS.APPROVED"
            :customLabel="$nova.labelsName('access_management','commentary_approved_label','Approved')"
            size="sm"
          />
          <StatusIndicator
            v-else-if="item.stage === 'Rejected'"
            :variant="STATUS_VARIANTS.REJECTED"
            :customLabel="$nova.labelsName('access_management','commentary_rejected_label','Rejected')"
            size="sm"
          />
          <StatusIndicator
            v-else-if="item.stage === 'inProgress'"
            :variant="STATUS_VARIANTS.IN_PROGRESS"
            customLabel="In Progress"
            size="sm"
          />
          <StatusIndicator
            v-else-if="item.stage === 'Retry'"
            :variant="STATUS_VARIANTS.FAILED"
            customLabel="Failed"
            size="sm"
          />
          <StatusIndicator
            v-else
            :variant="STATUS_VARIANTS.UNKNOWN"
            customLabel="Unknown"
            size="sm"
          />
        </template>
        <template v-slot:action="{ item }">
          <v-tooltip bottom content-class="tooltip-bottom">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="" @click="getDetails(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <!-- <v-tooltip bottom content-class="tooltip-bottom" v-if="item.type === 'accesschange' && item.stage === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="success" @click="approveItem(item)">
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </template>
            <span>Approve</span>
          </v-tooltip>
          <v-tooltip bottom content-class="tooltip-bottom" v-if="item.type === 'accesschange' && item.stage === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" color="error" @click="rejectItem(item)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Reject</span>
          </v-tooltip> -->
        </template>
      </lb-datatablenew>
    </div>
    <div v-else class="title grey--text pa-5 text-center">
      No Data Found
    </div>
    <lb-dialog v-model="viewdialog" :heading="viewdata.typetext" content-class="access-model" :loading="viewloading">
      <template v-slot:body>
        <div v-if="viewdata._id" class="d-flex flex-column gap-3">
          <div class="d-flex align-center" v-if="showMateriality">
            <!-- RU Level Materiality File Upload -->
            <div class="d-flex gap-3 flex-wrap"
              v-if="viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type == 'bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel'">
              <div class="status-card open">
                <h6 class="label font-weight-medium">
                  {{ viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type == 'bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel' ? 'Total RU'
                  :'' }}
                </h6>
                <h3 class="count">{{total_cycle ? total_cycle.length :  '-' }}</h3>
              </div>
              <div class="status-card approved">
                <h6 class="label font-weight-medium">
                  {{ viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type =='bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel' ? 'Processed RU' :'' }}
                </h6>
                <h3 class="count">{{proccesed_cycle ? proccesed_cycle?.length : '-' }}</h3>
              </div>
              <div v-if="viewdata.stage >= 0 && viewdata.stage <= 2"
                class="status-card in-progress">
                <h6 class="label font-weight-medium">
                  {{ viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type =='bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel' ? 'Pending RU' :'' }}
                </h6>
                <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle?.length - proccesed_cycle?.length : '-' }}</h3>
              </div>
              <div v-else-if="viewdata.stage == -1"
                class="status-card rejected">
                <h6 class="label font-weight-medium">
                  {{ viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type =='bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel' ? 'Rejected RU' :'' }}
                </h6>
                <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle?.length - proccesed_cycle?.length : '-' }}</h3>
              </div>
              <div v-else-if="viewdata.stage == 3"
                class="status-card failed">
                <h6 class="label font-weight-medium">
                  {{ viewdata.type == 'bulkmaterialityrulevel' || viewdata.type == 'filematerialityrulevel' || viewdata.type == 'bulkmaterialitygllevel' || viewdata.type == 'filematerialitygllevel' || viewdata.type == 'bulkmaterialitysllevel' || viewdata.type == 'filematerialitysllevel' ? 'Failed RU'
                  :'' }}
                </h6>
                <h3 class="count">{{total_cycle && proccesed_cycle ? total_cycle?.length - proccesed_cycle?.length : '-'}}</h3>
              </div>
            </div>
            <v-spacer></v-spacer>
            <!-- <div class="ml-4" v-if="['bulkmaterialityrulevel','filematerialityrulevel','bulkmaterialitygllevel','filematerialitygllevel','materialityrulevel','materialitygllevel','bulkmaterialitysllevel','filematerialitysllevel','materialitysllevel'].indexOf(viewdata.type) > -1">
              <v-icon @click= "viewinfo=true">mdi mdi-information-outline</v-icon>
            </div> -->
          </div>

          <!-- Applicable Period -->
          <v-row v-if="viewdata.data?.[0]?.from" no-gutters class="mb-2 align-center" data-testid="individual-approvals-list__applicable-period-row">
            <v-col cols="12" sm="3" class="details-label">Applicable Period</v-col>
            <v-col cols="12" sm="9" class="details-value">
              {{ $nova.formatDate(viewdata.data[0]?.from, "MM - YYYY") }}
            </v-col>
          </v-row>

          <!-- Module -->
          <v-row
           v-if="['materialityrulevel','materialitygllevel','materialitysllevel','bulkmaterialityrulevel','filematerialityrulevel','bulkmaterialitygllevel','filematerialitygllevel','bulkmaterialitysllevel','filematerialitysllevel'].includes(viewdata.type)
              && viewdata.network_details?.[0]?.name" no-gutters class="mb-2 align-center" data-testid="individual-approvals-list__cycle-row">
            <v-col cols="12" sm="3" class="details-label">
             Module
            </v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold" data-testid="individual-approvals-list__cycle-value">
              <span v-if="viewdata.reporting_type === 'bs'">
                Balance Sheet
              </span>
              <span v-else>
                Profit & Loss
              </span>
            </v-col>
          </v-row>

          <!-- Cycle -->
          <v-row
           v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
              && viewdata.network_details?.[0]?.name" no-gutters class="mb-2 align-center" data-testid="individual-approvals-list__cycle-row">
            <v-col cols="12" sm="3" class="details-label">
              {{$nova.labelsName('access_management','cycle_label','Cycle')}}
            </v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold" data-testid="individual-approvals-list__cycle-value">
              <span v-if="viewdata.data[0]?.cycle === 'Actual'">
                {{ actualLabel }}
              </span>
              <span v-else>
                {{ forecastLabel }}
              </span>
            </v-col>
          </v-row>

          <!-- Network -->
          <v-row
            v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
              && viewdata.network_details?.[0]?.name"
            no-gutters class="mb-2 align-center"
            data-testid="individual-approvals-list__network-row"
          >
            <v-col cols="12" sm="3" class="details-label">
              {{$nova.labelsName('access_management','division_label','Network')}}
            </v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold">
              {{ viewdata.network_details[0].name }}
            </v-col>
          </v-row>

          <!-- Region -->
          <v-row
            v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
              && viewdata.region_details?.[0]?.name"
            no-gutters class="mb-2 align-center"
            data-testid="individual-approvals-list__region-row"
          >
            <v-col cols="12" sm="3" class="details-label">
              {{$nova.labelsName('access_management','region_label','Region')}}
            </v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold">
              {{ viewdata.region_details[0].name }}
            </v-col>
          </v-row>

          <!-- Country -->
          <v-row
            v-if="['materialityrulevel','materialitygllevel','materialitysllevel'].includes(viewdata.type)
              && viewdata.country_details?.[0]?.name"
            no-gutters class="mb-2 align-center"
            data-testid="individual-approvals-list__country-row"
          >
            <v-col cols="12" sm="3" class="details-label">
              {{$nova.labelsName('access_management','country_label','Country')}}
            </v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold">
              {{ viewdata.country_details[0].name }}
            </v-col>
          </v-row>

          <!-- Status -->
           <v-row no-gutters class="align-center" data-testid="individual-approvals-list__status-row">
            <v-col cols="12" sm="3" class="details-label">Status</v-col>
            <v-col cols="12" sm="9" class="details-value font-weight-semibold">
              <status-indicator
                v-if="viewdata.stage === 0"
                :variant="STATUS_VARIANTS.OPEN"
                customLabel="Open"
                size="sm"
                outlined
                cornerRadius="8px"
              />
              <status-indicator
                v-else-if="viewdata.stage === 1 || viewdata.stage === 2"
                :variant="STATUS_VARIANTS.IN_PROGRESS"
                customLabel="In Progress"
                size="sm"
                outlined
                cornerRadius="8px"
              />
              <status-indicator
                v-else-if="viewdata.stage === -1"
                :variant="STATUS_VARIANTS.REJECTED"
                :customLabel="$nova.labelsName('access_management','commentary_rejected_label','Rejected')"
                size="sm"
                outlined
                cornerRadius="8px"
              />
              <status-indicator
                v-else-if="viewdata.stage === 3"
                :variant="STATUS_VARIANTS.FAILED"
                customLabel="Failed"
                size="sm"
                outlined
                cornerRadius="8px"
              />
              <status-indicator 
                v-else-if="viewdata.stage === 3"
                :variant="STATUS_VARIANTS.APPROVED"
                :customLabel="$nova.labelsName('access_management','commentary_approved_label','Approved')"
                size="sm"
                outlined
                cornerRadius="8px"
              />
            </v-col>
          </v-row>

          <!-- Access Change Details -->
          <div v-if="viewdata.type === 'accesschange' || viewdata.type === 'bulkaccesschange'" class="d-flex flex-column gap-4">
            <v-chip class="noTransform ru-info-chip gap-2 align-center">
              <span><v-icon>mdi-information-outline</v-icon> New users will be added/removed inline with the information provided below.</span>
            </v-chip>
            <v-card class="pa-4 d-flex flex-column gap-4" outlined>
              <div class="" v-if="viewdata.data[0]?.reportingunit_detail?.length > 0">
                <v-row no-gutters class="align-center">
                  <v-col cols="12" sm="3">
                    <div class="">Selected {{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Units') }}</div>
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                    <div label class="" :key="k"
                      v-for="(v,k) in viewdata.reportingunit_detail">
                      <v-chip label class="RU-Chip"><span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span></v-chip>
                    </div>
                  </v-col>
                </v-row>              
              </div>
              <div v-if="viewdata.data[0]?.adduser" class="">
                <v-row no-gutters>
                  <v-col cols="12" sm="3">
                    <div class="">
                      <span class="font-weight-bold border-left-success">Add Users</span>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex flex-column gap-3">
                    <v-row v-if="(viewdata.data[0].adduser?.submitter || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        {{ $nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer') }}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.submitter || [])" :key="k">
                          <span class="details-value noTransform">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].adduser?.approver || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        {{ $nova.labelsName('access_management','commentary_local_approver_label','Local Approver') }}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.approver || [])" :key="k">
                          <span class="details-value noTransform">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].adduser?.manager || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        Manager(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.manager || [])" :key="k">
                          <span class="details-value noTransform">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].adduser?.regional_approver || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        {{$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')}}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].adduser?.regional_approver || [])" :key="k">
                          <span class="details-value noTransform">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>

              <div v-if="viewdata.data[0]?.removeuser" class="mt-2">
                <v-row>
                  <v-col cols="12" sm="3">
                    <div class="">
                      <span class="font-weight-bold border-left-error">Remove Users</span>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex flex-column gap-3">
                    <v-row v-if="(viewdata.data[0].removeuser?.submitter || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        {{$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')}}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip  class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.submitter || [])" :key="k">
                          <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].removeuser?.approver || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        {{ $nova.labelsName('access_management','commentary_local_approver_label','Local Approver') }}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.approver || [])" :key="k">
                          <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].removeuser?.manager || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label font-weight-medium">
                        Manager(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.manager || [])" :key="k">
                          <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>

                    <v-row v-if="(viewdata.data[0].removeuser?.regional_approver || []).length > 0" no-gutters class="gap-2 align-center">
                      <v-col cols="12" sm="3" class="details-label  font-weight-medium">
                        {{$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')}}(s)
                      </v-col>
                      <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                        <v-chip class="ru-info-chip" v-for="(v,k) in (viewdata.data[0].removeuser?.regional_approver || [])" :key="k">
                          <span class="details-value textLowercase">{{viewdata.__userlist[v]?.email || "Unknown"}}</span>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </div>

          <!-- File Access Change -->
          <div v-else-if="viewdata.type === 'fileaccesschange'" class="d-flex flex-column gap-4">
            <v-chip class="noTransform ru-info-chip gap-2 align-center">
              <span class="d-flex gap-2 align-center"><v-icon>mdi-information-outline</v-icon> All existing user of the below {{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Units') }} will be replaced by the user list provided
            under each {{$nova.labelsName('access_management','ru_entity_plural_label','Reporting Units').toLowerCase()}} detail.</span>
            </v-chip>
            <v-card class="pa-4" outlined>
              <div class="" v-for="(v,k) in viewdata.data" :key="k">
              <v-row no-gutters class="">
                <v-col cols="12" sm="3">
                  <v-row no-gutters class="align-center mb-2">
                    <v-col cols="12" sm="12">
                        <div label class="">
                          <span class="noTransform ">{{viewdata.__reportingunit_detail[v.rucode].code}} - {{viewdata.__reportingunit_detail[v.rucode].name}}</span>
                        </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="9" class="d-flex flex-column gap-3">
                  <div class="">
                    <div class="mt-1 ml-4">
                      <v-row v-if="(v?.submitter || []).length > 0" no-gutters class="gap-2 mb-2">
                        <v-col cols="12" sm="3" class="details-label font-weight-medium">
                          {{ $nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer') }}(s)
                        </v-col>
                        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                          <v-chip class="ru-info-chip" v-for="(vv,vk) in (v?.submitter || [])" :key="vk">
                            <span class="details-value noTransform">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                      <v-row v-if="(v?.approver || []).length > 0" no-gutters class="gap-2 mb-2">
                        <v-col cols="12" sm="3" class="details-label font-weight-medium">
                          {{$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')}}(s)
                        </v-col>
                        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                          <v-chip class="ru-info-chip" v-for="(vv,vk) in (v?.approver || [])" :key="vk">
                            <span class="details-value noTransform">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                      <v-row v-if="(v?.manager || []).length > 0" no-gutters class="gap-2 mb-2">
                        <v-col cols="12" sm="3" class="details-label font-weight-medium">
                          Manager(s)
                        </v-col>
                        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                          <v-chip class="ru-info-chip" v-for="(vv,vk) in (v?.manager || [])" :key="vk">
                            <span class="details-value noTransform">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                      <v-row v-if="(v?.regional_approver || []).length > 0" no-gutters class="gap-2 mb-2">
                        <v-col cols="12" sm="3" class="details-label font-weight-medium">
                          {{ $nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver') }}(s)
                        </v-col>
                        <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                          <v-chip class="ru-info-chip" v-for="(vv,vk) in (v?.regional_approver || [])" :key="vk">
                            <span class="details-value noTransform">{{viewdata.__userlist[vv]?.email || "Unknown"}}</span>
                          </v-chip>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-divider class="my-2" />
            </div>
            </v-card>
          </div>

          <!-- Bulk RU Level Materiality -->
          <div v-else-if="viewdata.type === 'materialityrulevel' || viewdata.type === 'bulkmaterialityrulevel'">
            <div class="">
              <v-row no-gutters class="align-center">
                <v-col cols="12" sm="3">
                  <div class="details-label">Selected {{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Units') }}</div>
                </v-col>
                <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                  <div label class="" :key="k" v-for="(v,k) in viewdata.reportingunit_detail">
                    <v-chip label class="RU-Chip">
                      <span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span>
                      <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(v._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2">
              <!-- {{ ruheaders }} {{ruheadersbulk}} -->
              <lb-datatablenew :headers="viewdata.type === 'materialityrulevel' ? ruheadersbulk : ruheadersbulk" :items="gldata['ru'] || []"
                :enableslot="['rucode','datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional','management_thresholds_amount_regional','management_thresholds_percent_regional','floor_management_thresholds_amount_regional']">
                <template v-slot:rucode="{ item }">
                  <div class="text-left noTransform">
                    {{ item.rucode }} - {{ item.runame }}
                  </div>
                </template>
                <template v-slot:datatypes="">
                  <div class='d-flex flex-column gap-6'>
                  <div class='text-left '>
                    vs {{ proformaLabel }}
                  </div>
                  <div class='text-left '>
                    vs {{ forecastLabel }}
                  </div>
                  </div>
                </template>
                <template v-slot:control_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                    {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input " v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                    {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_control_thresholds_amount="{ item }">
                  <div class="" v-if="item.floor_control_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.floor_control_thresholds_amount_proforma) || 0 }}</div>
                    <div class="" v-else>-</div>
                  <div class="" v-if="item.floor_control_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.floor_control_thresholds_amount_forecast) || 0 }}</div>
                    <div class="" v-else>-</div>
                </template> -->
                <template v-slot:management_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                    {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                    {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_management_thresholds_amount="{ item }">
                  <div class="" v-if="item.floor_management_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_proforma) }}</div>
                    <div class="" v-else>-</div>
                  <div class="" v-if="item.floor_management_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_forecast) }}</div>
                    <div class="" v-else>-</div>
                </template> -->
                <template v-slot:control_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                    {{ item.control_thresholds_percent_regional_proforma }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                    {{ item.control_thresholds_percent_regional_forecast }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_control_thresholds_amount_regional="{ item }">
                  <div class="" v-if="item.floor_control_thresholds_amount_regional_proforma">
                    {{ item.floor_control_thresholds_amount_regional_proforma }}%</div>
                    <div class="" v-else>-</div>
                  <div class="" v-if="item.floor_control_thresholds_amount_regional_forecast">
                    {{ item.floor_control_thresholds_amount_regional_forecast }}%</div>
                    <div class="" v-else>-</div>
                </template> -->
                <template v-slot:management_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                    {{ item.management_thresholds_amount_regional_proforma }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_management_thresholds_amount_regional="{ item }">
                  <div class="" v-if="item.floor_management_thresholds_amount_regional_proforma">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_regional_proforma) }}</div>
                    <div class="" v-else>-</div>
                  <div class="" v-if="item.floor_management_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_regional_forecast) }}</div>
                    <div class="" v-else>-</div>
                </template> -->
              </lb-datatablenew>
            </div>
          </div>

          <!-- File RU Level Materiality -->
          <div v-else-if="viewdata.type === 'filematerialityrulevel'">
            <div class="" v-for="(v,k) in Object.fromEntries(Object.entries(gldata).slice(materialityDetailsPage*25, (materialityDetailsPage+1)*25))" :key="k">
              <div class="">
                <v-row no-gutters class="align-center">
                  <v-col cols="12" sm="3">
                    <div class="font-weight-regular">{{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Unit') }}</div>
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                      <v-chip label class="RU-Chip">
                        <span class="noTransform RU-Chip-Text">{{viewdata.__reportingunit_detail[k].code}} - {{viewdata.__reportingunit_detail[k].name}}</span>
                        <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(viewdata.__reportingunit_detail[k]._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                      </v-chip>
                  </v-col>
                </v-row>
              </div>
              <template v-for="(vv, kk) in ['actual', 'forecast']">
                <div v-if="(gldata[k] || {})[vv]" :key="kk" class="mt-4">
                  <!-- <div class="font-weight-regular">{{typekeys[vv]}}</div> -->
                  <lb-datatablenew :headers="ruheaders" :items="gldata[k][vv] || []"
                    :enableslot="['datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional', 'management_thresholds_amount_regional', 'management_thresholds_percent_regional', 'floor_management_thresholds_regional']"
                    :perpage='5'>
                    <template v-slot:datatypes=''>
                      <div class='d-flex flex-column gap-6'>
                    <div class='text-left '>
                      vs {{ proformaLabel }}
                    </div>
                    <div class='text-left '>
                      vs {{ forecastLabel }}
                    </div>
                    </div>
                    </template>
                    <template v-slot:control_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                        {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                        {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_control_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:management_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                        {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                        {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_management_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_management_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.floor_management_thresholds_amount_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_management_threshold_amount_forecast">
                        {{ $nova.formatNumber(item.floor_management_threshold_amount_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:control_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                        {{ item.control_thresholds_percent_regional_proforma }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                        {{ item.control_thresholds_percent_regional_forecast }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_control_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:management_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                        {{ item.management_thresholds_amount_regional_proforma }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_management_thresholds_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                  </lb-datatablenew>
                </div>
              </template>
              <v-divider class="my-2" />
            </div>
          </div>

          <!-- Bulk GL Level Materiality -->
          <div v-else-if="viewdata.type === 'materialitygllevel' || viewdata.type === 'bulkmaterialitygllevel'">
            <div class="">
              <v-row no-gutters class="align-center">
                <v-col cols="12" sm="3">
                  <div class="details-label">Selected {{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Units') }}</div>
                </v-col>
                <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                  <div label class="" :key="k" v-for="(v,k) in viewdata.reportingunit_detail">
                    <v-chip label class="RU-Chip">
                      <span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span>
                      <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(v._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2">
              <lb-datatablenew  :headers="viewdata.type === 'materialitygllevel' ? glheaders : glheadersbulk" :items="gldata['one'] || []" class="v-table-color"
                :enableslot="['rucode','code','datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional', 'management_thresholds_amount_regional', 'management_thresholds_percent_regional', 'floor_management_thresholds_amount_regional']">
                 <template v-slot:rucode="{ item }">
                  <div>
                  {{ item.rucode }} - {{ item.runame }}
                  </div>
                </template>
                <template v-slot:code="{ item }">
                  <div>
                  {{ item.code }} - {{ item.name }}
                  </div>
                </template>
                <template v-slot:datatypes=''>
                  <div class='d-flex flex-column gap-6'>
                  <div class='text-left '>
                    vs {{ proformaLabel }}
                  </div>
                  <div class='text-left '>
                    vs {{ forecastLabel }}
                  </div>
                  </div>
                </template>
                <template v-slot:control_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                    {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                    {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_control_thresholds_amount="{ item }">
                  <div class="text-left" v-if="item.floor_control_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.floor_control_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left" v-else>-</div>
                  <div class="text-left" v-if="item.floor_control_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.floor_control_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left" v-else>-</div>
                </template> -->
                <template v-slot:management_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                    {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                    {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_management_thresholds_amount="{ item }">
                  <div class="text-left" v-if="item.floor_management_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_proforma) }}</div>
                    <div class="text-left" v-else>-</div>
                  <div class="text-left" v-if="item.floor_management_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_forecast) }}</div>
                    <div class="text-left" v-else>-</div>
                </template> -->
                <template v-slot:control_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                    {{ item.control_thresholds_percent_regional_proforma }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                    {{ item.control_thresholds_percent_regional_forecast }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_control_thresholds_amount_regional="{ item }">
                  <div class="text-left" v-if="item.floor_control_thresholds_amount_regional_proforma">
                    {{ item.floor_control_thresholds_amount_regional_proforma }}%</div>
                    <div class="text-left" v-else>-</div>
                  <div class="text-left" v-if="item.floor_control_thresholds_amount_regional_forecast">
                    {{ item.floor_control_thresholds_amount_regional_forecast }}%</div>
                    <div class="text-left" v-else>-</div>
                </template> -->
                <template v-slot:management_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                    {{ item.management_thresholds_amount_regional_proforma }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input  " v-if="item.management_thresholds_percent_regional_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <!-- <template v-slot:floor_management_thresholds_amount_regional="{ item }">
                  <div class="text-left" v-if="item.floor_management_thresholds_amount_regional_proforma">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_regional_proforma) }}</div>
                    <div class="text-left" v-else>-</div>
                  <div class="text-left" v-if="item.floor_management_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.floor_management_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left" v-else>-</div>
                </template> -->
              </lb-datatablenew>
            </div>
          </div>

          <!-- File GL Level Materiality -->
          <div v-else-if="viewdata.type === 'filematerialitygllevel'">
            <div class="" v-for="(v,k) in Object.fromEntries(Object.entries(gldata).slice(materialityDetailsPage*25, (materialityDetailsPage+1)*25))" :key="k">
              <div class="">
                <v-row no-gutters class="align-center">
                  <v-col cols="12" sm="3">
                    <div class="font-weight-regular">{{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Unit') }}</div>
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                      <v-chip label class="RU-Chip">
                        <span class="noTransform RU-Chip-Text">{{viewdata.__reportingunit_detail[k].code}} - {{viewdata.__reportingunit_detail[k].name}}</span>
                        <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(viewdata.__reportingunit_detail[k]._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                      </v-chip>
                  </v-col>
                </v-row>
              </div>
              <template v-for="(vv, kk) in ['actual', 'forecast']">
                <div v-if="(gldata[k] || {})[vv]" :key="kk" class="mt-4">
                  <!-- <div class="font-weight-regular">{{typekeys[vv]}}</div> -->
                  <lb-datatablenew :headers="glheadersbulk" :items="gldata[k][vv] || []"
                    :enableslot="['datatypes', 'control_thresholds_amount', 'control_thresholds_percent', 'floor_control_thresholds_amount', 'management_thresholds_amount', 'management_thresholds_percent', 'floor_management_thresholds_amount', 'control_thresholds_amount_regional', 'control_thresholds_percent_regional', 'floor_control_thresholds_amount_regional', 'management_thresholds_amount_regional', 'management_thresholds_percent_regional', 'floor_management_thresholds_amount_regional']"
                    :perpage='5'>
                    <template v-slot:datatypes=''>
                      <div class='d-flex flex-column gap-6'>
                      <div class='text-left '>
                        vs {{ proformaLabel }}
                      </div>
                      <div class='text-left '>
                        vs {{ forecastLabel }}
                      </div>
                      </div>
                    </template>
                    <template v-slot:control_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                        {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                        {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_control_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:management_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                        {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                        {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_management_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_management_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.floor_management_thresholds_amount_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_management_threshold_amount_forecast">
                        {{ $nova.formatNumber(item.floor_management_threshold_amount_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:control_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                        {{ item.control_thresholds_percent_regional_proforma }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                        {{ item.control_thresholds_percent_regional_forecast }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_control_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                    <template v-slot:management_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                        {{ item.management_thresholds_amount_regional_proforma }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <!-- <template v-slot:floor_management_thresholds_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.floor_control_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.floor_control_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template> -->
                  </lb-datatablenew>
                </div>
              </template>
              <v-divider class="my-2" />
            </div>
          </div>

          <!-- SL Level Materiality -->
          <div v-else-if="viewdata.type === 'materialitysllevel' || viewdata.type === 'bulkmaterialitysllevel'">
            <div class="">
              <v-row no-gutters class="align-center">
                <v-col cols="12" sm="3">
                  <div class="details-label">Selected {{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Units') }}</div>
                </v-col>
                <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                  <div label class="" :key="k" v-for="(v,k) in viewdata.reportingunit_detail">
                    <v-chip label class="RU-Chip">
                      <span class="noTransform RU-Chip-Text">{{v.code}} - {{v.name}}</span>
                      <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(v._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="mt-2">
              <lb-datatablenew :headers="viewdata.type === 'materialitysllevel' ? slheaders : slheadersbulk" :items="gldata['one'] || []"
                :enableslot="slMaterialityEnableSlots">
                 <template v-slot:rucode="{ item }">
                  <div>
                  {{ item.rucode }} - {{ item.runame }}
                  </div>
                 </template>
                  <template v-slot:glcode="{ item }">
                  <div>
                  {{ item.glcode }} - {{ item.glname }}
                  </div>
                 </template>
                  <template v-slot:slcode="{ item }">
                  <div>
                  {{ item.slcode }} - {{ item.slname }}
                  </div>
                 </template>
                <template v-slot:datatypes=''>
                 <div class='d-flex flex-column gap-6'>
                  <div class='text-left '>
                    vs {{ proformaLabel }}
                  </div>
                  <div class='text-left '>
                    vs {{ forecastLabel }}
                  </div>
                  </div>
                </template>
                <template v-slot:control_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                    {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                    {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_amount="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                    {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                    {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:control_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                    {{ item.control_thresholds_percent_regional_proforma }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                    {{ item.control_thresholds_percent_regional_forecast }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_amount_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                    {{ item.management_thresholds_amount_regional_proforma }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
                <template v-slot:management_thresholds_percent_regional="{ item }">
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_proforma">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                  <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                    {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                    <div class="text-left cell-input" v-else>-</div>
                </template>
              </lb-datatablenew>
            </div>
          </div>

          <!-- File SL Level Materiality -->
          <div v-else-if="viewdata.type === 'filematerialitysllevel'">
            <div class="" v-for="(v,k) in Object.fromEntries(Object.entries(gldata).slice(materialityDetailsPage*25, (materialityDetailsPage+1)*25))" :key="k">
              <div class="">
                <v-row no-gutters class="">
                  <v-col cols="12" sm="3">
                    <div class="font-weight-regular">{{ $nova.labelsName('access_management','ru_entity_plural_label','Reporting Unit') }}</div>
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value d-flex align-center flex-wrap gap-2">
                      <v-chip label class="RU-Chip">
                        <span class="noTransform RU-Chip-Text">{{viewdata.__reportingunit_detail[k].code}} - {{viewdata.__reportingunit_detail[k].name}}</span>
                        <v-icon small color="success" class="ml-2" v-if="proccesed_Ru?.includes(viewdata.__reportingunit_detail[k]._id) && (viewdata.stage === 'inProgress' || viewdata.stage === 2 || viewdata.stage === 'retry' || viewdata.stage === 3 || viewdata.stage === 'Approved' || viewdata.stage === 1 )">mdi-check-circle</v-icon>
                      </v-chip>
                  </v-col>
                </v-row>
              </div>
              <template v-for="(vv, kk) in ['actual', 'forecast']">
                <div v-if="(gldata[k] || {})[vv]" :key="kk" class="mt-4">
                  <div class="font-weight-regular">{{typekeys[vv]}}</div>
                  <lb-datatablenew :headers="slheaders" :items="gldata[k][vv] || []"
                    :enableslot="slMaterialityEnableSlots"
                    :perpage='5'>
                    <template v-slot:rucode="{ item }">
                      <div>
                        {{ item.rucode }} - {{ item.runame }}
                      </div>
                    </template>
                    <template v-slot:glcode="{ item }">
                      <div>
                        {{ item.glcode }} - {{ item.glname }}
                      </div>
                    </template>
                    <template v-slot:slcode="{ item }">
                      <div>
                        {{ item.slcode }} - {{ item.slname }}
                      </div>
                    </template>
                    <template v-slot:datatypes=''>
                      <div class='d-flex flex-column gap-6'>
                    <div class='text-left '>
                      vs {{ proformaLabel }}
                    </div>
                    <div class='text-left '>
                      vs {{ forecastLabel }}
                    </div>
                  </div>
                    </template>
                    <template v-slot:control_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_proforma">
                        {{ item.control_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_forecast">
                        {{ item.control_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_amount="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_amount_proforma) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_forecast) || 0 }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_proforma">
                        {{ item.management_thresholds_percent_proforma || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_forecast">
                        {{ item.management_thresholds_percent_forecast || 0 }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_proforma">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_proforma) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.control_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:control_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_proforma">
                        {{ item.control_thresholds_percent_regional_proforma }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.control_thresholds_percent_regional_forecast">
                        {{ item.control_thresholds_percent_regional_forecast }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_amount_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_proforma">
                        {{ item.management_thresholds_amount_regional_proforma }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_amount_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_amount_regional_forecast) }}</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                    <template v-slot:management_thresholds_percent_regional="{ item }">
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_proforma">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_proforma) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                      <div class="text-left cell-input" v-if="item.management_thresholds_percent_regional_forecast">
                        {{ $nova.formatNumber(item.management_thresholds_percent_regional_forecast) }}%</div>
                        <div class="text-left cell-input" v-else>-</div>
                    </template>
                  </lb-datatablenew>
                </div>
              </template>
              <v-divider class="my-2" />
            </div>
          </div>

          <!-- GL Selection Change -->
          <div v-else-if="viewdata.type=== 'glselectionchange'">
            <div class="">
              <div class="d-flex flex-column gap-3">
                <div v-if="(viewdata?.periods || []).length" class="selected-months" data-testid="individual-approvals-list__applicable-periods-section">
                  <v-row no-gutters class="align-center">
                    <v-col cols="12" sm="3" class="details-label">
                      {{$nova.labelsName('access_management','applicable_periods_label','Applicable Periods')}}
                    </v-col>
                    <v-col cols="12" sm="9" class="details-value" data-testid="individual-approvals-list__applicable-periods-list">
                      <ul class="applicable-periods-list gap-2">
                        <li v-for="(month, index) in viewdata?.periods" :key="index" class="month-item" data-testid="individual-approvals-list__applicable-periods-item">
                          {{ month }}
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </div>
                <!-- <v-row no-gutters class="align-center" data-testid="individual-approvals-list__status-row">
                  <v-col cols="12" sm="3" class="details-label">
                    {{$nova.labelsName('access_management','status_label','Status')}}
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value" data-testid="individual-approvals-list__status-value">
                    <StatusIndicator outlined cornerRadius="8px" size="sm"  :variant="getVariant(viewdata.stage)" :label="getLabel(viewdata.stage)" />
                  </v-col>
                </v-row> -->
                <v-row no-gutters class="align-center" data-testid="individual-approvals-list__selected-network-row">
                  <v-col cols="12" sm="3" class="details-label">
                    {{$nova.labelsName('access_management','division_label','Selected Network')}}
                  </v-col>
                  <v-col cols="12" sm="9" class="details-value" data-testid="individual-approvals-list__selected-network-value">
                    <v-chip label class="mr-2" data-testid="individual-approvals-list__selected-network-chip">
                      {{ viewdata.network_detail?.name || ""}}
                    </v-chip>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="mt-3">
              <lb-datatablenew :headers="gldetailTableHeaders" :items="viewdata.gldetail" :loading='viewloading' :enableslot="['selected_sl']">
                <template v-slot:selected_sl="{ item }">
                  <span>
                    {{ item.selected_sl ? 'Selected' : 'Un-Selected' }}
                  </span>
                </template>
              </lb-datatablenew>
            </div>
          </div>
        </div>
        <div v-else-if="viewloading" class="grey--text py-4 text-center font-size-lg">Loading Data...</div>
        <div v-else class="grey--text py-4 text-center font-size-lg">No data found</div>
      </template>
      <template v-slot:actions>
        <div class="d-flex align-center">
          <div v-if="(viewdata.type === 'filematerialitygllevel' || viewdata.type === 'filematerialityrulevel' || viewdata.type === 'filematerialitysllevel') && (Object.keys(gldata).length > 25)" class="grey--text py-4 text-center font-size-lg"> 
            <v-btn @click="materialityDetailsPage--" :disabled="materialityDetailsPage === 0"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
            <span class="ml-1 mr-1" v-if="(($nova.formatNumber((Object.keys(gldata).length)/25))-materialityDetailsPage-1) !== 0">{{ materialityDetailsPage+1}} of {{ $nova.formatNumber((Object.keys(gldata).length)/25) }}</span>
            <span class="ml-1 mr-1" v-if="(($nova.formatNumber((Object.keys(gldata).length)/25))-materialityDetailsPage-1) === 0">End</span>
            <v-btn @click="materialityDetailsPage++" :disabled="(((Object.keys(gldata).length)/25)-materialityDetailsPage-1) <= 0"><v-icon>mdi mdi-arrow-right </v-icon></v-btn>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="error" v-if="viewdata.stage === 0 && display !== 'view'" class="" @click="rejectItem(viewdata)"><span>Reject</span></v-btn>
          <v-btn color="success" @click="approveItem(viewdata)" v-if="viewdata.stage === 3 && display !== 'view'"><span>Retry</span></v-btn>
          <v-btn color="success" @click="approveItem(viewdata)" v-if="viewdata.stage === 0 && display !== 'view'"><span>Approve</span></v-btn>
        </div>
      </template>
    </lb-dialog>
    <lb-dialog v-model="viewinfo" width="400" heading="Column Notations">
      <template v-slot:body>
        <v-card-text class="pa-4">
          <div class="my-1">
            <span class="noTransform">LC Amt</span>
            <span class="ml-1">-</span>
            <span class="ml-2 noTransform">Local control amount</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">LC %</span>
            <span class="ml-5">-</span>
            <span class="ml-2 noTransform">Local control percentage</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">LM Amt</span>
            <span class="ml-1">-</span>
            <span class="ml-2 noTransform">Local management amount</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">LM %</span>
            <span class="ml-4">-</span>
            <span class="ml-2 noTransform">Local management percentage</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">RC Amt</span>
            <span class="ml-1">-</span>
            <span class="ml-2 noTransform">Regional control amount</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">RC %</span>
            <span class="ml-4">-</span>
            <span class="ml-2 noTransform">Regional control percentage</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">RM Amt </span>
            <span class="ml-1">-</span>
            <span class="ml-2 noTransform">Regional management amount</span>
          </div>
          <v-divider></v-divider>
          <div class="my-1">
            <span class="noTransform">RM %</span>
            <span class="ml-4">-</span>
            <span class="ml-2 noTransform">Regional management percentage</span>
          </div>
          <v-divider></v-divider>
        </v-card-text>
      </template>
      </lb-dialog>
  </div>
</template>
<script>
import CountSection from './GlSelection/CountSection.vue';
import StatusIndicator from '../components/StatusIndicator.vue';
import { STATUS_VARIANTS } from '../utils/statusConstants';
import helpers from '../utils/helpers';
import { SL_MATERIALITY_ENABLE_SLOTS } from './Approvals/components/constants';

export default {
  name: 'approval_list',
  components: {
    CountSection,
    StatusIndicator
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    display: {
      type: String,
      default: "view",
    },
    customHeaders: {
      type: Array,
      default: ()=> [],
    },
    pendingCountDisplay: {
      type: Boolean,
      default: true
    },
    approvedCountDisplay: {
      type: Boolean,
      default: true
    },
    rejectedCountDisplay: {
      type: Boolean,
      default: true
    },
    showMateriality: {
      type: Boolean,
      default: true
    },
    showReportingType: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleHeaders() {
      if (!this.showReportingType) {
        return this.headers.filter(h => h.value !== 'reporting_type');
      }
      return this.headers;
    },
    /**
     * Dynamic label for Actual based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    actualLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on reporting_type
     * Returns balance sheet specific label when type is 'bs', otherwise default
     */
    proformaLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on reporting_type
     * Returns balance sheet specific label when type is 'bs'
     */
    forecastLabel() {
      return this.viewdata.reporting_type === 'bs'
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
  },
  data: function(){
    return {
      STATUS_VARIANTS,
      viewloading: false,
      viewdialog: false,
      viewdata: {},
      gldata: {},
      type: "",
      requestdata: {},
      colors: {},
      formatteddata: [],
      selecteditem: "",
      typekeys: {"actual": "Actual", "forecast": "Forecast"},
      slMaterialityEnableSlots: SL_MATERIALITY_ENABLE_SLOTS,
      headers: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
        },
        {
          value: "typetext",
          text: "Request type",
          sortable: false,
          filterable: true,
          datatype: "string",
          lock: true,
          visible: false,
        },
        {
          type: "string",
          value: "submittername",
          text: "Submitted by",
          sortable: false,
          filterable: true,
          // lock: true,
        },
        {
          type: "date",
          value: "created_at",
          text: "Submitted on",
          sortable: true,
          defaultsort: 'desc'
          // lock: true,
        },
        
        {
          type: "string",
          value: "stage",
          text: "Status",
          sortable: false,
          filterable: false,
          // lock: true,
        },
        {
          type: "string",
          value: "reporting_type",
          text: "Module",
          sortable: false,
          filterable: true,
          // lock: true,
        },
        {
          value: "action",
          text: "Action",
          sortable: false,
          // lock: true,
        }
      ],
      glheaders: [
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
        {
          value: "rucode",
          text: "RU Code & Name",
          sortable: false,
          filterable: false,
        },
        {
          value: "code",
          text: "GL Code & Name",
          sortable: false,
          filterable: false,
        },
        // {
        //   value: "name",
        //   text: "Name",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          value: "datatypes",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      glheadersbulk:[
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
        // {
        //   value: "rucode",
        //   text: "RU Code & Name",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          value: "code",
          text: "GL Code & Name",
          sortable: false,
          filterable: false,
        },
        // {
        //   value: "name",
        //   text: "Name",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          value: "datatypes",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      ruheaders: [
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
         {
          value: "rucode",
          text: "RU code & description",
          sortable: false,
          filterable: false,
        },
        {
          value: "datatypes",
          text: "",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      ruheadersbulk: [
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
        {
          value: "datatypes",
          text: "",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      slheaders: [
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
        {
          value: "rucode",
          text: "RU code & description",
          sortable: false,
          filterable: false,
        },
        {
          value: "glcode",
          text: "GL code & description",
          sortable: false,
          filterable: false,
        },
        {
          value: "slcode",
          text: "Drill down description",
          sortable: false,
          filterable: false,
        },
        {
          value: "datatypes",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      slheadersbulk:[
        {
          value: "period",
          text: "Period",
          sortable: false,
          filterable: false,
        },
        {
          value: "glcode",
          text: "GL code & description",
          sortable: false,
          filterable: false,
        },
        {
          value: "slcode",
          text: "Drill down description",
          sortable: false,
          filterable: false,
        },
        {
          value: "datatypes",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt",
          alignment: "text-right",
          sortable: false,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %",
          alignment: "text-right",
          sortable: false,
        },
      ],
      dataStatusCount:{"open":0,'approved':0,'rejected':0,'inProgress':0,'retry':0},
      gldetailTableHeaders : [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
          alignment: "text-center"
        },
        {
          text:'GL Code',
          value:'code',
          filterable: true
        },
        {
          text:"GL Description",
          value:'name'
        },
        {
          text:"Drill-down Selection",
          value:'selected_sl',
          alignment: "text-left"
        }
      ],
      reportingunit:'',
      proccesed_Ru:'',
      viewinfo:false,
      total_cycle:'',
      proccesed_cycle:'',
      materialityDetailsPage:0
    }
  },
  activated() {
    this.refreshData();
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    getVariant(stage) {
      if (stage === 'Open' || stage === 0) return STATUS_VARIANTS.OPEN;
      if (stage === 'Approved' || stage === 1) return STATUS_VARIANTS.APPROVED;
      if (stage === 'Rejected' || stage === -1) return STATUS_VARIANTS.REJECTED;
      if (stage === 'inProgress' || stage === 2) return STATUS_VARIANTS.IN_PROGRESS;
      if (stage === 'Retry' || stage === 3) return STATUS_VARIANTS.FAILED;
      return STATUS_VARIANTS.UNKNOWN;
    },
    getLabel(stage) {
      if (stage === 'Approved' || stage === 1) {
        return this.$nova.labelsName('access_management', 'commentary_approved_label', 'Approved');
      }
      return undefined;
    },
    refreshData() {
      if(this.display !== "view") this.headers.push();
      this.formatteddata = this.formatData(this.data);
      if(this.customHeaders.length>0){
        this.headers = this.customHeaders;
      }
    },
    getDetails(item) {
      this.viewloading = true;
      this.viewdialog = true;
      this.viewdata = {};
      this.selecteditem = item;
      this.materialityDetailsPage = 0;
      let url = "/v2/varianceanalysis/approvals/getdetail/"
      if(item.type === 'glselectionchange'){
        url = "/v2/varianceanalysis/approvals/glselectiongetdetail/"
      }
      helpers.apiGet.call(this, url+item._id).then(dt => {
        if(dt.data.status === "success") {
          this.viewdata = dt.data.data || {};
          this.reportingunit= dt.data.data.reportingunit;
          this.proccesed_Ru = dt.data.data.proccesed_Ru;
          this.total_cycle= dt.data?.data?.total_cycle || [];
          this.proccesed_cycle = dt.data?.data?.proccesed_cycles || [];
          if(this.viewdata.userlist instanceof Array){
            let t = {};
            for (const i of this.viewdata.userlist) {
              t[i._id] = i;
            }
            this.viewdata.__userlist = t;
          }
          if(this.viewdata.reportingunit_detail instanceof Array){
            let t = {};
            for (const i of this.viewdata.reportingunit_detail) {
              t[i._id] = i;
            }
            this.viewdata.__reportingunit_detail = t;
          }
          if(this.viewdata.gllist instanceof Array){
            let t = {};
            for (const i of this.viewdata.gllist) {
              t[i._id] = i;
            }
            this.viewdata.__gllist = t;
          }
          if(this.viewdata.type === "materialityrulevel" || this.viewdata.type === "bulkmaterialityrulevel"){
            this.gldata = {"ru": this.formatGLData(this.viewdata.data[0]?.materiality || {})}
            this.updateStageById(this.formatteddata, dt.data.data._id ,dt.data.data.stage)
          }
          else if(this.viewdata.type === "filematerialityrulevel"){
            this.gldata = {}
            for (const i of (this.viewdata.data[0]?.materiality || [])) {
              this.gldata[i.rucode] = this.gldata[i.rucode] || {};
              if(i.actual) {
                this.gldata[i.rucode]["actual"] = this.gldata[i.rucode]["actual"] || [];
                this.gldata[i.rucode]["actual"].push({ ...(i.actual || {}), glcode: i.glcode,period:i?.period || '-' })
              }
              if(i.forecast) {
                this.gldata[i.rucode]["forecast"] = this.gldata[i.rucode]["forecast"] || [];
                this.gldata[i.rucode]["forecast"].push({ ...(i.forecast || {}), glcode: i.glcode,period:i?.period || '-' })
              }
            }
            for (const k in this.gldata) {
              if (Object.hasOwnProperty.call(this.gldata, k)) {
                const el = this.gldata[k];
                if(el.actual) el.actual = this.formatGLData(el.actual, k);
                if(el.forecast) el.forecast = this.formatGLData(el.forecast, k);
              }
            }
            this.updateStageById(this.formatteddata, dt.data.data._id, dt.data.data.stage);
          }
          else if(this.viewdata.type === "materialitygllevel" || this.viewdata.type === "bulkmaterialitygllevel"){
            this.gldata = {"one": this.formatGLData(this.viewdata.data[0]?.materiality || [])}
            this.updateStageById(this.formatteddata, dt.data.data._id ,dt.data.data.stage)
          }
          else if(this.viewdata.type === "filematerialitygllevel"){
            this.gldata = {}
            for (const i of (this.viewdata.data[0]?.materiality || [])) {
              this.gldata[i.rucode] = this.gldata[i.rucode] || {};
              for (const j of i.data || []) {
                if (j.actual) {
                  this.gldata[i.rucode]["actual"] = this.gldata[i.rucode]["actual"] || [];
                  this.gldata[i.rucode]["actual"].push({ ...(j.actual || {}), glcode: j.glcode, period:j.period ?? '-' })
                }
                if (j.forecast) {
                  this.gldata[i.rucode]["forecast"] = this.gldata[i.rucode]["forecast"] || [];
                  this.gldata[i.rucode]["forecast"].push({ ...(j.forecast || {}), glcode: j.glcode, period:j.period ?? '-' })
                }
              }
            }
            for (const k in this.gldata) {
              if (Object.hasOwnProperty.call(this.gldata, k)) {
                const el = this.gldata[k];
                if(el.actual) el.actual = this.formatGLData(el.actual, k);
                if(el.forecast) el.forecast = this.formatGLData(el.forecast, k);
              }
            }
            this.updateStageById(this.formatteddata, dt.data.data._id, dt.data.data.stage);
          }
          else if(this.viewdata.type === "materialitysllevel" || this.viewdata.type === "bulkmaterialitysllevel"){
            this.gldata = {"one": this.formatSLData(this.viewdata.data[0]?.materiality || [])}
            this.updateStageById(this.formatteddata, dt.data.data._id ,dt.data.data.stage)
          }
          else if(this.viewdata.type === "filematerialitysllevel"){
            this.gldata = {}
            for (const i of (this.viewdata.data[0]?.materiality || [])) {
              this.gldata[i.rucode] = this.gldata[i.rucode] || {};
              for (const j of i.data || []) {
                if (j.actual) {
                  this.gldata[i.rucode]["actual"] = this.gldata[i.rucode]["actual"] || [];
                  this.gldata[i.rucode]["actual"].push({ ...(j.actual || {}), glcode: j.glcode, slcode: j.slcode, period:j.period ?? '-' })
                }
                if (j.forecast) {
                  this.gldata[i.rucode]["forecast"] = this.gldata[i.rucode]["forecast"] || [];
                  this.gldata[i.rucode]["forecast"].push({ ...(j.forecast || {}), glcode: j.glcode, slcode: j.slcode, period:j.period ?? '-' })
                }
              }
            }
            for (const k in this.gldata) {
              if (Object.hasOwnProperty.call(this.gldata, k)) {
                const el = this.gldata[k];
                if(el.actual) el.actual = this.formatSLData(el.actual, k);
                if(el.forecast) el.forecast = this.formatSLData(el.forecast, k);
              }
            }
            this.updateStageById(this.formatteddata, dt.data.data._id, dt.data.data.stage);
          }
          else if(this.viewdata.data[0].type === 'glselectionchange'){
            this.viewdata = this.viewdata.data[0] || []
            if(typeof this.viewdata.data[0]?.gls_actual !== 'undefined'){
              this.viewdata.data[0].cycle = 'Actual'
            }else{
              this.viewdata.data[0].cycle = 'Forecast'
            }
          }
        }else throw new Error ("Error reading data");
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      }).finally(() => {
        this.viewloading = false;
      })
    },
    getReportingUnitDetail(ruId) {
      if (ruId) {
        return this.viewdata.__reportingunit_detail?.[ruId] || {};
      }
      return this.viewdata.reportingunit_detail?.[0] || {};
    },
    formatGLData(dt, ruId){ 
      let ndt = [];
      const ruDetail = this.getReportingUnitDetail(ruId);
      for (const i of dt) {
        ndt.push({
            rucode: ruDetail.code ?? "",
            runame: ruDetail.name ?? "",
            code: this.viewdata.__gllist?.[i.glcode]?.code ?? "",
            name: this.viewdata.__gllist?.[i.glcode]?.name ?? "",
            control_thresholds_amount_proforma: i?.control_thresholds_amount_proforma ?? '',
            control_thresholds_percent_proforma: i?.control_thresholds_percent_proforma || '',
            management_thresholds_amount_proforma: i?.management_thresholds_amount_proforma || '',
            management_thresholds_percent_proforma: i?.management_thresholds_percent_proforma || '',
            control_thresholds_amount_regional_proforma: i?.control_thresholds_amount_regional_proforma || '',
            control_thresholds_percent_regional_proforma: i?.control_thresholds_percent_regional_proforma || '',
            management_thresholds_amount_regional_proforma: i?.management_thresholds_amount_regional_proforma || '',
            management_thresholds_percent_regional_proforma: i?.management_thresholds_percent_regional_proforma || '',
            control_thresholds_amount_forecast: i?.control_thresholds_amount_forecast ?? '',
            control_thresholds_percent_forecast: i?.control_thresholds_percent_forecast || '',
            management_thresholds_amount_forecast: i?.management_thresholds_amount_forecast || '',
            management_thresholds_percent_forecast: i?.management_thresholds_percent_forecast || '',
            control_thresholds_amount_regional_forecast: i?.control_thresholds_amount_regional_forecast || '',
            control_thresholds_percent_regional_forecast: i?.control_thresholds_percent_regional_forecast || '',
            management_thresholds_amount_regional_forecast: i?.management_thresholds_amount_regional_forecast || '',
            management_thresholds_percent_regional_forecast: i?.management_thresholds_percent_regional_forecast || '',
            period: i.period ?? '-'
          }
        )
      }
      return ndt;
    },
    formatSLData(dt, ruId){
      let ndt = [];
      const ruDetail = this.getReportingUnitDetail(ruId);
      for (const i of dt) {
        const glDetail = this.viewdata.__gllist?.[i.glcode] || {};
        const slDetail = (i.slcode && this.viewdata.__gllist?.[i.slcode]) || glDetail;
        ndt.push({
            rucode: ruDetail.code ?? "",
            runame: ruDetail.name ?? "",
            glcode: glDetail.code ?? "",
            glname: glDetail.name ?? "",
            slcode: slDetail.code ?? "",
            slname: slDetail.name ?? "",
            control_thresholds_amount_proforma: i?.control_thresholds_amount_proforma ?? '',
            control_thresholds_percent_proforma: i?.control_thresholds_percent_proforma || '',
            management_thresholds_amount_proforma: i?.management_thresholds_amount_proforma || '',
            management_thresholds_percent_proforma: i?.management_thresholds_percent_proforma || '',
            control_thresholds_amount_regional_proforma: i?.control_thresholds_amount_regional_proforma || '',
            control_thresholds_percent_regional_proforma: i?.control_thresholds_percent_regional_proforma || '',
            management_thresholds_amount_regional_proforma: i?.management_thresholds_amount_regional_proforma || '',
            management_thresholds_percent_regional_proforma: i?.management_thresholds_percent_regional_proforma || '',
            control_thresholds_amount_forecast: i?.control_thresholds_amount_forecast ?? '',
            control_thresholds_percent_forecast: i?.control_thresholds_percent_forecast || '',
            management_thresholds_amount_forecast: i?.management_thresholds_amount_forecast || '',
            management_thresholds_percent_forecast: i?.management_thresholds_percent_forecast || '',
            control_thresholds_amount_regional_forecast: i?.control_thresholds_amount_regional_forecast || '',
            control_thresholds_percent_regional_forecast: i?.control_thresholds_percent_regional_forecast || '',
            management_thresholds_amount_regional_forecast: i?.management_thresholds_amount_regional_forecast || '',
            management_thresholds_percent_regional_forecast: i?.management_thresholds_percent_regional_forecast || '',
            period: i.period ?? '-'
          }
        )
      }
      return ndt;
    },
    approveItem(item) {
      this.viewloading = true;
      let url ='/v2/varianceanalysis/approvals/approve/'
      if (item.type === 'glselectionchange'){
        url = '/v2/varianceanalysis/approvals/approveforglselection/'
      }
      this.axios.post(url+item._id).then(dt => {
        if(dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Change request approved and the changes will be impacted only if there is/are no conflicts");
          this.requestdata = dt.data.data[0] || {};
          const newStage = helpers.resolveApprovedStage(dt.data.data, item.type || this.viewdata?.type);
          this.updateStageById(this.formatteddata, item._id, newStage);
          this.viewdialog = false;
        }
        else throw dt.data.message;
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      }).finally(() => {
        this.viewloading = false;
      })
    },
    rejectItem(item) {
      this.viewloading = true;
      let url = '/v2/varianceanalysis/approvals/reject/'
      if (item.type === 'glselectionchange') {
        url = '/v2/varianceanalysis/approvals/rejectforglselection/'
      }
      this.axios.post(url+item._id).then(dt => {
        if(dt.data.status === "success") {
          this.$store.commit("sbSuccess", "Change request rejected");
          this.requestdata = dt.data.data[0] || {};
          item.stage = -1;
          this.selecteditem.stage = 'Rejected';
          this.updateStageById(this.formatteddata,item._id, -1);
          this.viewdialog = false;
        }
        else throw dt.data.message;
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.error(err);
      }).finally(() => {
        this.viewloading = false;
      })
    },
    setColors(){
      this.colors = {};
      let colorlist = this.$nova.getColors(14, 0.2);
      this.colors["materialityrulevel"] = colorlist[0];
      this.colors["bulkmaterialityrulevel"] = colorlist[1];
      this.colors["materialitygllevel"] = colorlist[2];
      this.colors["bulkmaterialitygllevel"] = colorlist[3];
      this.colors["filematerialityrulevel"] = colorlist[4];
      this.colors["filematerialitygllevel"] = colorlist[5];
      this.colors["materialitysllevel"] = colorlist[6];
      this.colors["bulkmaterialitysllevel"] = colorlist[7];
      this.colors["filematerialitysllevel"] = colorlist[8];
      this.colors["glorder"] = colorlist[9];
      this.colors["accesschange"] = colorlist[10];
      this.colors["bulkaccesschange"] = colorlist[11];
      this.colors["fileaccesschange"] = colorlist[12];
      this.colors["glselectionchange"] = colorlist[13];
    },
    formatData: function(data){
      this.dataStatusCount = { "open": 0, 'approved': 0, 'rejected': 0, 'inProgress': 0, 'retry': 0 };
      let ArrayTemp = [];
      data.forEach((i, k) => {
        i.__key = k;
        i.indexno = k + 1;
        let stageName = "";
        let reportingType = "";
        if (i.stage === 0 || i.stage === "Open") {
          stageName = "Open"
          this.dataStatusCount.open++
        }
        else if(i.stage === 1 || i.stage === "Approved"){
          stageName ="Approved"
          this.dataStatusCount.approved++
        }
        else if(i.stage === -1 || i.stage === "Rejected"){
          stageName = "Rejected"
          this.dataStatusCount.rejected++
        }
        else if(i.stage === 2 || i.stage === "inProgress"){
          stageName = "inProgress"
          this.dataStatusCount.open++
        }
        else if(i.stage === 3 || i.stage === "Retry"){
          stageName = "Retry"
          this.dataStatusCount.retry++
        }
         reportingType = helpers.getReportingTypeLabel(i.reporting_type);
        i.reporting_type = reportingType
        i.stage = stageName;
        i.submittername= i.submitter_detail?.displayname || ""
        i.approvedby = i.approver_detail?.displayname || ""
        i.approvedon = i.approvedate || "";
        i.stageName = stageName;
        ArrayTemp.push(i);
      });
      this.setColors();
      return ArrayTemp;
    },
    updateStageById: function(data, id, newStage) {
      this.formatteddata = data.map(item =>
        item._id === id ? { ...item, stage: newStage} : item
      );
      this.formatteddata = this.formatData(this.formatteddata);
    },
  },
}
</script>
<style scoped>
.bg-grey
{
  background-color: rgb(236 236 236);
}

.selected-months {
  margin-top: 0px;
}
.selected-months ul {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap to the next line */
  padding: 0;
  margin: 0;
  list-style-type: none; /* Remove default list styling */
}
.month-item {
  display: flex;
  align-items: center;
  padding: 2px 4px;
  background-color: #ecf4f5; /* Background color for items */
  border-radius: 4px;
}
.border-left-success {
  color: var(--status-green);
}
.border-left-error {
  color: var(--status-red);
}

.ru-info-chip {
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  height: auto !important;
  padding: 4px 8px !important;
  width: max-content;
}

.RU-Chip {
  background-color: #f5f5f5 !important;
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
}

.RU-Chip-Text {
  font-weight: 500;
  color: #333;
}

.gap-2 {
  gap: 8px;
}

/* Status Card Styles */
.status-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  background: #f7f7f7;
  border: 1px solid;
  min-width: 190px;
}

.status-card .label {
  white-space: nowrap;
  margin-right: 8px;
  margin-bottom: 0;
}

.status-card .count {
  font-weight: 600;
  margin-bottom: 0;
}

.status-card.open {
  border-color: var(--grey-900);
  background-color: var(--grey-50);
  color: var(--grey-900);
}

.status-card.approved {
  border-color: var(--status-green);
  color: var(--green-800);
  background-color: var(--green-50);
}

.status-card.rejected {
  border-color: var(--status-red);
  color: var(--red-600);
  background-color: var(--red-50);
}

.status-card.failed {
  border-color: var(--status-red);
  color: var(--red-600);
  background-color: var(--red-50);
}

.status-card.in-progress {
  border-color: var(--status-yellow);
  color: var(--yellow-600);
  background-color: var(--yellow-50);
}
.v-table-color th {
 height: 48px !important;
}
.v-table-color td {
 height: 42px !important;
}
.bordervalues{
background: var(--grey-weak, #FAFAFA);
padding: var(--padding-2xs, 6px) var(--Space-2xs, 4px) !important;
}
.bordervalues .bordervalues-cell{
border-radius: var(--radius-sm, 8px);
border: 1px solid var(--grey-100, #E5E5E5);
background: var( --grey-white, #FFF);
padding: var(--Space-2xs, 4px) var(--Space-xs, 8px);

}
</style>

<style>
.access-model {
  min-width: 50% !important;
  max-width: 80% !important;
  width: auto !important;
}
</style>